/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_cat_howto = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Enter a value and choose the ${i?.category} units to convert from and to. The result updates instantly, and the swap button reverses the conversion.`)
};

const es_uc_cat_howto = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ingresa un valor y elige las unidades de ${i?.category} de las que conviertes y a las que conviertes. El resultado se actualiza al instante, y el botón de intercambio invierte la conversión.`)
};

const de_uc_cat_howto = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Geben Sie einen Wert ein und wählen Sie die ${i?.category}-Einheiten für Ausgangs- und Zieleinheit. Das Ergebnis aktualisiert sich sofort, und die Tauschen-Schaltfläche kehrt die Umrechnung um.`)
};

const nl_uc_cat_howto = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Voer een waarde in en kies de ${i?.category} eenheden om van en naar toe te converteren. Het resultaat wordt direct bijgewerkt en de wissel-knop keert de conversie om.`)
};

const fr_uc_cat_howto = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Entrez une valeur et choisissez les unités ${i?.category} à partir desquelles convertir et vers lesquelles convertir. Le résultat se met à jour instantanément, et le bouton d'inversion inverse la conversion.`)
};

const it_uc_cat_howto = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Immetti un valore e scegli le unità di ${i?.category} da cui convertire e verso cui convertire. Il risultato si aggiorna istantaneamente e il pulsante di scambio inverte la conversione.`)
};

const pt_br2_uc_cat_howto = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Digite um valor e escolha as unidades de ${i?.category} para converter de e para. O resultado é atualizado instantaneamente e o botão trocar reverte a conversão.`)
};

const pt_uc_cat_howto = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Introduza um valor e escolha as unidades de ${i?.category} a partir das quais está a converter e para as quais pretende converter. O resultado actualiza instantaneamente e o botão de troca inverte a conversão.`)
};

const ja_uc_cat_howto = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`値を入力し、変換する${i?.category}単位を選択します。結果が即座に更新されます。スワップボタンで変換を逆にできます。`)
};

const zh_uc_cat_howto = /** @type {(inputs: { category: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`[pending translation]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ category: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_cat_howto = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_cat_howto(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_cat_howto", locale)
	if (locale === "en") return en_uc_cat_howto(inputs)
	if (locale === "es") return es_uc_cat_howto(inputs)
	if (locale === "de") return de_uc_cat_howto(inputs)
	if (locale === "nl") return nl_uc_cat_howto(inputs)
	if (locale === "fr") return fr_uc_cat_howto(inputs)
	if (locale === "it") return it_uc_cat_howto(inputs)
	if (locale === "pt-BR") return pt_br2_uc_cat_howto(inputs)
	if (locale === "pt") return pt_uc_cat_howto(inputs)
	if (locale === "ja") return ja_uc_cat_howto(inputs)
	return zh_uc_cat_howto(inputs)
};